var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-link',_vm._g(_vm._b({staticClass:"link--icon"},'base-link',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),(_vm.icon)?_c('v-icon',{staticClass:"ml-1",attrs:{"small":"","aria-hidden":"true","translate":"no"}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }